import React, { useContext } from 'react'
import { useCookies } from 'react-cookie'
import { useJWTValidation } from './hooks'
import { loginWithRedirect, logout } from './utils'

const DEFAULT_REDIRECT_CALLBACK = () =>
  window.history.replaceState({}, document.title, window.location.pathname)

export const SessionContext = React.createContext()
export const useSession = () => useContext(SessionContext)

export const SessionProvider = ({
  children,
  onRedirectCallback = DEFAULT_REDIRECT_CALLBACK,
  ...initOptions
}) => {
  const rawCookie = useCookies([window.env.SESSION_COOKIE])?.[0]?.[
    window.env.SESSION_COOKIE
  ]
  // Remove the Bearer+ part
  const jwt = rawCookie?.slice(7)

  const { data, isLoading, isSuccess } = useJWTValidation(jwt)
  const user = data?.data

  return (
    <SessionContext.Provider
      value={{
        raw: rawCookie,
        jwt,
        isAuthenticated: isSuccess,
        loading: isLoading,
        user,
        loginWithRedirect,
        logout,
      }}
    >
      {children}
    </SessionContext.Provider>
  )
}
